import 'css-chunksrc/client/pages/documentsPage/documentsPage/preview/docxRenderer/styles.scss';export default {
  "renderer": "_renderer_101hm_1",
  "content": "_content_101hm_9"
};